import { FC } from 'react'
import { SocialNetwork } from 'models/socialCampaign'
import facebook from 'assets/img/socialNetworks/facebook.svg'
import instagram from 'assets/img/socialNetworks/instagram.svg'
import linkedin from 'assets/img/socialNetworks/linkedin.svg'
import styles from './NetworkMark.module.sass'
import tiktok from 'assets/img/socialNetworks/tiktok.svg'

/**
 * A network's round brand mark, LOCAL to the marketing campaign (prototype v3 `netMark`).
 * Files, not inlined SVGs: the Figma exports reuse the same gradient and clip ids. TikTok's is the
 * prototype's placeholder until the Figma export exists. Decorative: the caller names the network.
 */
const MARKS: Record<SocialNetwork, string> = {
  [SocialNetwork.INSTAGRAM]: instagram,
  [SocialNetwork.FACEBOOK]: facebook,
  [SocialNetwork.LINKEDIN]: linkedin,
  [SocialNetwork.TIKTOK]: tiktok,
}

interface Props {
  network: SocialNetwork
  /** Width and height in px. @default 20 */
  size?: number
}

export const NetworkMark: FC<Props> = ({ network, size = 20 }) => (
  <img className={styles.mark} src={MARKS[network]} width={size} height={size} alt="" data-network={network} />
)
